import gql from 'graphql-tag';

export const FRAGMENT_CUSTOM_TONE_OF_VOICE = gql`
  fragment CustomToneOfVoice on CustomToneOfVoice {
    id
    name
    description
    isDefault
    status
  }
`;
